/**
 * Toggle off before release to silence verbose IAP diagnostics.
 * Does not affect user-facing toasts — only console logging.
 */
export const IAP_DEBUG_LOGS = true;

/**
 * When true, the iOS paywall shows a temporary technical summary (product IDs, resolve flags).
 * Toggle off before App Store release.
 */
export const IAP_PAYWALL_DEBUG_PANEL = true;

export function iapDebug(event: string, payload?: Record<string, unknown>): void {
  if (!IAP_DEBUG_LOGS) return;
  if (payload && Object.keys(payload).length > 0) {
    console.log(`[iOS IAP] ${event}`, payload);
  } else {
    console.log(`[iOS IAP] ${event}`);
  }
}

export function iapDebugWarn(event: string, payload?: Record<string, unknown>): void {
  if (!IAP_DEBUG_LOGS) return;
  if (payload && Object.keys(payload).length > 0) {
    console.warn(`[iOS IAP] ${event}`, payload);
  } else {
    console.warn(`[iOS IAP] ${event}`);
  }
}

/** Serialize plugin / native errors for logs (avoids empty {}). */
export function serializeIapError(err: unknown): { message: string; raw: string; code?: number } {
  if (err == null) {
    return { message: "Unknown error", raw: "null" };
  }
  if (typeof err === "string") {
    return { message: err, raw: err };
  }
  if (err instanceof Error) {
    const code = (err as Error & { code?: number }).code;
    return {
      message: err.message || "Error",
      raw: err.stack || err.message,
      ...(typeof code === "number" ? { code } : {}),
    };
  }
  if (typeof err === "object") {
    const o = err as Record<string, unknown>;
    const code = typeof o.code === "number" ? o.code : undefined;
    const message =
      typeof o.message === "string"
        ? o.message
        : typeof o.reason === "string"
          ? o.reason
          : "Purchase error";
    let raw: string;
    try {
      raw = JSON.stringify(err, Object.getOwnPropertyNames(err));
    } catch {
      raw = String(err);
    }
    return { message, raw, ...(code !== undefined ? { code } : {}) };
  }
  return { message: String(err), raw: String(err) };
}
